<template>
	<VDataGridV2
		class="leads-page"
		sticky
		:loader="loader"
		paginated
	>
		<VDataGridColumnV2
			id="id"
			label="ID"
			width="80px"
		>
			<template #default="{ row }">
				{{ row.id }}
			</template>
		</VDataGridColumnV2>

		<VDataGridColumnV2
			id="name"
			label="Контактное лицо"
			width="200px"
			sortable
		/>

		<VDataGridColumnV2
			id="contacts"
			label="Контакты"
		>
			<template #default="{ row }">
				<div v-if="row.phone">
					{{ row.phone }}
				</div>
				<div v-if="row.email">
					{{ row.email }}
				</div>
			</template>
		</VDataGridColumnV2>

		<VDataGridColumnV2
			id="createdAt"
			label="Дата создания"
			width="200px"
		>
			<template #default="{ row }">
				<div class="title">
					{{ LeadsService.getSourceLabel(row) }}
				</div>
				<div
					v-if="row.updatedAt"
					class="description updated"
				>
					Обновлен: {{ $core.utils.date.humanizeDate(row.updatedAt) }}
				</div>
				<div class="description">
					Создан: {{ $core.utils.date.humanizeDate(row.createdAt) }}
				</div>
			</template>
		</VDataGridColumnV2>

		<VDataGridColumnV2
			id="priority"
			label="Приоритет"
			width="140px"
			content-align="center"
		>
			<template #default="{ row }">
				<VNode :node="LeadsService.getPriorityVNode(row)" />
			</template>
		</VDataGridColumnV2>

		<VDataGridColumnV2
			id="data"
			label="Комментарии"
		>
			<template #default="{ row }">
				<v-node :node="getLeadActions(row)" />
				<footer>
					<VButton
						:ref="'add_comment_lead_' + row.id"
						theme="link"
						@click="showAddCommentPopup(row)"
					>
						Добавить комментарий
					</VButton>
				</footer>
			</template>
		</VDataGridColumnV2>
	</VDataGridV2>

	<VPopup
		class="add-lead-comment"
		:target="comment.target"
		:visible="comment.visible"
		closable
		show-pointer
		not-hide-on-click
		position="bottom"
		align="right"
		@close="hideAddCommentPopup"
	>
		<VTextarea v-model="comment.value" />

		<VButton
			theme="primary"
			:disabled="isCommentEmpty"
			@click="saveComment"
		>
			Сохранить
		</VButton>
	</VPopup>
</template>

<style lang="scss" src="./LeadsRegistry.scss"/>

<script>

import DataGridLoader    	from '@/lib/components/VDataGridV2/DataGridLoader';
import LeadsService      	from '@/domains/Leads/LeadsService';

export default {
	name: 'LeadsRegistry',

	data() {
		return {
			LeadsService,

			comment: {
				visible: false,
				target:  null,
				entity:  null,
				value:   null,
			},

			isLoading: false,
			loader: new DataGridLoader(LeadsService.getListPaginated),
		};
	},

	computed: {
		currentUser() {
			return this.$core.currentUser;
		},
		isCommentEmpty() {
			return !this.comment.value || this.comment.value.trim().length === 0;
		},
	},

	methods: {
		showAddCommentPopup(lead) {
			this.comment.target = this.$refs[`add_comment_lead_${lead.id}`];
			if (this.comment.target === null || typeof this.comment.target === 'undefined') return;
			this.comment.entity = lead;
			this.comment.visible = true;
		},
		hideAddCommentPopup() {
			this.comment.visible = false;
			this.comment.target = null;
			this.comment.entity = null;
			this.comment.value = null;
		},

		getLeadActions(lead) {
			const { data } = lead || {};

			if (!(this.$core.utils.isObject(data) && Array.isArray(data.actions))) {
				return h('article', {
					innerHTML: 'Нет данных',
				});
			}

			return data.actions.map(item => h(
				'article',
				{
					class: { 'action-item': true },
				},
				[
					h('div', {
						class:    { content: true },
						innerHTML: item.body,
					}),
					h('footer', [
						h('div', {
							class:    { 'created-by': true },
							innerHTML: item.createdBy.name,
						}),
						h('div', {
							class:    { 'created-at': true },
							innerHTML: this.$core.utils.date.humanizeDate(new Date(item.createdAt)),
						}),
					]),
				],
			));
		},

		async saveComment() {
			try {
				if (this.isLoading) return;
				this.isLoading = true;

				if (!(this.$core.utils.string.isString(this.comment.value) && this.comment.value.length > 0)) {
					this.hideAddCommentPopup();
					return;
				}

				const payload = {...this.comment.entity};
				if (!(this.$core.utils.isObject(payload) && this.$core.utils.isObject(payload.data))) {
					payload.data = {};
				}
				if (!Array.isArray(payload.data.actions)) {
					payload.data.actions = [];
				}

				payload.data.actions.push({
					body: this.comment.value,
					createdBy: {
						id: this.currentUser.id,
						name: this.currentUser.name,
					},
					createdAt: new Date().toISOString(),
				});

				const ok = await LeadsService.update(payload);

				if (ok) {
					this.comment.entity.data = {...payload.data};
					this.hideAddCommentPopup();
					this.loader.refresh();
				}
			} catch (e) {
				this.$core.error('Произошла ошибка ', e);
			} finally {
				this.isLoading = false;
			}

		},
	},
};
</script>
